import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { z } from "zod"

import { removeUndefined } from "@tfg/types/schemas/utils"

export const useSearchParamsFilters = (schema: z.ZodType) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const updateSearchParams = useCallback(
    (filters: z.infer<typeof schema>) => {
      setSearchParams((prev) => ({
        ...prev,
        ...removeUndefined(filters),
      }))
    },
    [setSearchParams]
  )

  const searchParamsObject = useMemo(
    () => Object.fromEntries(searchParams.entries()),
    [searchParams]
  )

  const filters = useMemo(
    () => schema.parse(searchParamsObject),
    [searchParamsObject, schema]
  )

  return [filters, updateSearchParams]
}
